<template>
  <div v-loading.body="loading">
    <div class="c_page-title">
      <div>分播机器列表</div>
      <el-button class="icon-fresh" type="primary" @click="beforeAddMachine">
        新增
      </el-button>
    </div>
    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div style="margin-bottom: 0">
          <el-table
            v-if="resData"
            ref="multipleTable"
            v-loading="tableLoading"
            max-height="600"
            :data="resData.list"
            tooltip-effect="dark"
            style="width: 100%"
          >
            <el-table-column
              align="center"
              prop="machine_id"
              label="设备id"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="machine_no"
              label="设备编号"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="grid_num"
              label="格口数量"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="ip"
              label="ip"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="port"
              label="端口号"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="admin_name"
              label="更新人"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="update_time"
              label="更新时间"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="grid_is_check_one_out"
              label="一键打包"
            ></el-table-column>
            <el-table-column
              fixed="right"
              label="操作"
              show-overflow-tooltip
              align="center"
            >
              <template #default="scope">
                <el-button
                  type="text"
                  size="small"
                  @click="editMachine(scope.row)"
                  >修改
                </el-button>
                <el-button
                  type="text"
                  style="color: #f56c6c"
                  size="small"
                  @click="delMachine(scope.row)"
                  >删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-col>
    </el-row>
    <edit
      v-if="visible"
      :machine_id="form.machine_id"
      :machine_no="form.machine_no"
      :grid_num="form.grid_num"
      :ip="form.ip"
      :port="form.port"
      :is_check_one_out="form.is_check_one_out"
      @onCloseDialog="closeBox"
    ></edit>

    <!-- 分播方案配置 -->
    <h3>分播方案配置</h3>
    <div class="machine_cut_case_setting">
      <el-form ref="form" :model="machine_cut_case_setting" inline>
        <el-form-item>
          <el-select
            v-model="machine_cut_case_setting.machine_id"
            placeholder="选择设备"
            @change="getCutCase"
          >
            <el-option
              v-for="item in resData.list"
              :key="item.machine_id"
              :value="item.machine_id"
              :label="item.machine_no"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select
            v-model="machine_cut_case_setting.machine_cut_type"
            placeholder="选择分播类型"
            @change="getCutCase"
          >
            <el-option
              v-for="(item, index) in resData.machine_cut_type"
              :key="index"
              :value="item.value"
              :label="item.label"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button
            type="danger"
            style="margin-left: 50px"
            @click="setCaseName"
            >增加分播方案
          </el-button>
        </el-form-item>
        <el-form-item v-if="machine_cut_case_setting.machine_cut_type ===DISTRIBUTION_TYPE.RETURN_DISTRIBUTION_GROUP">
          <el-button type="primary" @click="showBindPrinter"
            >绑定打印机
          </el-button>
        </el-form-item>
        <!-- 退换货分播不显示保存按钮 -->
        <template
          v-if="
            machine_cut_case_setting.machine_cut_type !==
            DISTRIBUTION_TYPE.RETURN_DISTRIBUTION_GROUP
          "
        >
          <el-form-item>
            <el-button type="primary" @click="saveCutCase">保存</el-button>
          </el-form-item>
        </template>
      </el-form>
      <!-- <div style="width: 100%; margin-top: 30px; display: flex"> -->
      <el-row :gutter="16">
        <el-col
          v-for="(item, key) in machine_cut_case_setting.case"
          :key="key"
          :span="6"
        >
          <el-card style="width: 100%">
            <div slot="header" class="clearfix">
              <span
                v-if="
                  machine_cut_case_setting.machine_cut_type ===
                  DISTRIBUTION_TYPE.INBOUND_DISTRIBUTION
                "
              >
                入库分播包裹号必填
                <el-switch
                  v-model="machine_cut_case_setting.case[0].is_need_package"
                  active-color="#409EFF"
                  inactive-color="#999"
                  active-value="1"
                  inactive-value="0"
                >
                </el-switch
              ></span>
              <span
                v-else-if="
                  machine_cut_case_setting.machine_cut_type ===
                  DISTRIBUTION_TYPE.RETURN_DISTRIBUTION_GROUP
                "
              >
                <el-upload
                  ref="upload"
                  :action="action"
                  style="display: inline-flex"
                  name="excel"
                  :limit="1"
                  :show-file-list="false"
                  :multiple="false"
                  :data="{
                    machine_cut_type: machine_cut_case_setting.machine_cut_type,
                    machine_id: machine_cut_case_setting.machine_id,
                    case_name: item.case_name,
                    case_id: item.case_id,
                  }"
                  with-credentials
                  :on-success="handleUploadResult"
                >
                  <el-button size="small" type="primary">导入</el-button>
                </el-upload>
                <el-button
                  size="small"
                  type="primary"
                  style="margin-left: 10px"
                  @click="showConfig(item)"
                  >配置</el-button
                >
              </span>
              <span v-else>&nbsp;</span>
              <el-button
                type="text"
                style="
                  font-size: 20px;
                  font-weight: 800;
                  float: right;
                  padding: 3px 0;
                "
                @click="rename(key)"
                >{{ item.case_name }}
                <i class="el-icon-edit" style="font-size: 20px" />
              </el-button>
            </div>

            <!--  方案 -->
            <el-table :data="item.grid_setting" border>
              <el-table-column
                prop="grid_no"
                label="格口号"
                align="center"
              ></el-table-column>
              <template
                v-if="
                  [DISTRIBUTION_TYPE.RETURN_DISTRIBUTION_GROUP].includes(
                    machine_cut_case_setting.machine_cut_type
                  )
                "
              >
                <el-table-column
                  prop="method_text"
                  label="分播方式"
                  align="center"
                ></el-table-column>
              </template>
              <template v-else>
                <el-table-column
                  prop="cut_type"
                  label="分播类型"
                  align="center"
                ></el-table-column>
              </template>
              <el-table-column label="" align="center">
                <template #header>
                  格口配置
                  <i
                    v-if="
                      ![
                        DISTRIBUTION_TYPE.INBOUND_DISTRIBUTION,
                        DISTRIBUTION_TYPE.MEDIAN_DISTRIBUTION_GROUP,
                        DISTRIBUTION_TYPE.RETURN_DISTRIBUTION_GROUP,
                      ].includes(machine_cut_case_setting.machine_cut_type)
                    "
                    class="el-icon-close"
                    style="
                      color: #f00;
                      float: right;
                      font-size: 20px;
                      font-weight: 800;
                      cursor: pointer;
                    "
                    @click="removeCase(key)"
                  />
                </template>
                <template #default="scope">
                  <!-- 入库类型的时候是单选, 次品员分播类型是多选 -->
                  <el-select
                    v-if="
                      [
                        '1',
                        '2',
                        '4',
                        DISTRIBUTION_TYPE.MEDIAN_DISTRIBUTION_GROUP,
                      ].includes(machine_cut_case_setting.machine_cut_type)
                    "
                    :value="scope.row.grid_type"
                    :disabled="['1', '2'].includes(scope.row.is_sc_grid)"
                    size="small"
                    filterable
                    :multiple="
                      ['2', '4'].includes(
                        machine_cut_case_setting.machine_cut_type
                      )
                    "
                    placeholder="请选择"
                    @change="onGridTypeChange($event, key, scope.row)"
                  >
                    <el-option
                      v-for="gt in machine_grid_type[
                        machine_cut_case_setting.machine_cut_type
                      ]"
                      :key="gt.value"
                      :value="gt.value"
                      :label="gt.label"
                    >
                    </el-option>
                  </el-select>
                  <span
                    v-else-if="
                      [DISTRIBUTION_TYPE.RETURN_DISTRIBUTION_GROUP].includes(
                        machine_cut_case_setting.machine_cut_type
                      )
                    "
                  >
                    {{ scope.row.method_type_text }}
                  </span>
                  <!-- 中分位分播联级多选 -->
                  <el-cascader
                    v-else
                    v-model="scope.row.grid_type"
                    filterable
                    :options="
                      machine_grid_type[
                        machine_cut_case_setting.machine_cut_type
                      ]
                    "
                    :show-all-levels="false"
                    :props="{
                      expandTrigger: 'hover',
                      multiple: true,
                    }"
                  ></el-cascader>
                </template>
              </el-table-column>
              <el-table-column
                v-if="
                  machine_cut_case_setting.machine_cut_type ===
                    DISTRIBUTION_TYPE.INBOUND_DISTRIBUTION ||
                  machine_cut_case_setting.machine_cut_type ===
                    DISTRIBUTION_TYPE.MEDIAN_DISTRIBUTION_GROUP
                "
                width="120"
              >
                <template #header>
                  格口件数上限(仅限正常标)
                  <i
                    class="el-icon-close"
                    style="
                      color: #f00;
                      font-size: 20px;
                      font-weight: 800;
                      cursor: pointer;
                      position: absolute;
                      rigth: 0;
                      top: 0;
                    "
                    @click="removeCase(key)"
                  />
                </template>
                <template #default="scope">
                  <!-- 正常标格口才需要设置数量 -->
                  <el-input-number
                    v-if="
                      scope.row.grid_type == 1 ||
                      machine_cut_case_setting.machine_cut_type ===
                        DISTRIBUTION_TYPE.MEDIAN_DISTRIBUTION_GROUP
                    "
                    v-model="scope.row.max_cut_num"
                    :controls="false"
                    style="width: 90px"
                    size="small"
                    :min="0"
                  ></el-input-number>
                </template>
              </el-table-column>
              <!-- 按次品员分播才有"其他配置"下拉选项 -->
              <el-table-column
                v-if="
                  [2, 4].includes(
                    Number(machine_cut_case_setting.machine_cut_type)
                  )
                "
                :label="showOther ? '其他配置' : '不出库格口'"
                align="center"
                width="100"
              >
                <template #default="scope">
                  <div v-if="showOther">
                    <el-select
                      :value="scope.row.is_sc_grid"
                      clearable
                      @change="
                        selectScGrid($event, scope.row, item.grid_setting)
                      "
                    >
                      <el-option label="色差" value="1"></el-option>
                      <el-option label="微次" value="2"></el-option>
                      <el-option label="不出库格口" value="3"></el-option>
                    </el-select>
                  </div>
                  <div v-else>
                    <el-checkbox
                      v-model="scope.row.is_sc_grid"
                      true-label="1"
                      false-label="0"
                      @change="
                        checkScGrid($event, item.grid_setting, scope.$index)
                      "
                    ></el-checkbox>
                  </div>
                </template>
              </el-table-column>
              <!-- 退换货分播展示 -->
              <el-table-column
                v-if="
                  [DISTRIBUTION_TYPE.RETURN_DISTRIBUTION_GROUP].includes(
                    machine_cut_case_setting.machine_cut_type
                  )
                "
                align="center"
                width="100"
                label="其他配置"
                prop="grid_type"
              >
                <template #default="{ row }">
                  <span class="line-2">{{ row.grid_type }}</span>
                </template>
              </el-table-column>
            </el-table>
          </el-card>
        </el-col>
      </el-row>
      <!-- </div> -->
    </div>
    <el-dialog title="配置" :visible.sync="configDialogVisible" width="400px">
      <el-form :model="configForm" label-width="180px" style="margin-bottom: 20px;">
        <el-checkbox v-model="configForm.autoCheck"></el-checkbox>
        商家细分释放格口是否自动完成校验
      </el-form>
      <el-form :model="configForm" label-width="180px">
        <el-checkbox v-model="configForm.enableLimit"></el-checkbox>
        是否限制商品数量上限，默认值为
        <el-input-number
          v-model="configForm.limit"
          size="small"
          :min="1"
          :max="999999999"
          :precision="0"
          :step="1"
          :controls="true"
          controls-position="right"
          style="width: 120px"
          @input="configForm.limit = Math.floor(Math.abs(configForm.limit))"
        ></el-input-number>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="configDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleConfigSubmit">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 修改打印机绑定弹窗 -->
    <el-dialog
      title="绑定打印机"
      :visible.sync="printerDialogVisible"
      width="1000px"
      :close-on-click-modal="false"
    >
      <div class="transfer-container">
        <div style="width: 300px;">
          <el-table :data="printerList" border style="margin-right: 20px">
            <el-table-column label="打印机名称" align="center">
              <template #header>
                打印机名称
                <el-button type="primary" size="small" style="margin-left: 10px;" @click="showAddPrinter">新增</el-button
                >
              </template>
              <template #default="{ row }">
                <div style="display: flex; align-items: center; justify-content: space-between;">
                  <div>
                    <i 
                      class="el-icon-close" 
                      style="color: #f56c6c; cursor: pointer; margin-right: 10px;font-size: 20px;"  
                      @click.stop="deletePrinter(row)"
                    ></i>
                    <span :style="{ color: activeEditPrinterId && activeEditPrinterId !== row.id ? '#ddd' : 'inherit' }">{{ row.printer_name }}</span>
                  </div>
                  <div style="display: flex; gap: 8px;">
                    <el-button 
                      type="text" 
                      size="mini" 
                      @click.stop="handleEditMode(row)"
                    >编辑</el-button>
                    <el-button 
                      type="text" 
                      size="mini" 
                      @click.stop="editPrinter(row)"
                    >修改</el-button>
                  </div>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-transfer
          ref="cityTransfer"
          filterable
          :titles="['已绑定格口', '未绑定格口']"
          v-model="transferBinds"
          :data="transferData"
          @change="handleTransferChange"
          :target-order="'push'"
        ></el-transfer>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClosePrinterModal">取 消</el-button>
        <el-button type="primary" @click="savePrinterBinding">保 存</el-button>
      </span>
    </el-dialog>

    <!-- 添加/修改打印机弹窗 -->
    <el-dialog
      :title="editingPrinter ? '修改打印机' : '新增打印机'"
      :visible.sync="addPrinterVisible"
      width="400px"
      :close-on-click-modal="false"
    >
      <el-form :model="printerForm" label-width="80px">
        <el-form-item label="设备名称">
          <el-input
            v-model="printerForm.printer_name"
            placeholder="请输入打印机名称"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="ip">
          <el-input
            v-model="printerForm.ip"
            placeholder="请输入ip地址"
          ></el-input>
        </el-form-item> -->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addPrinterVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleAddPrinter">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Edit from "./components/edit.vue";
import {
  postGetMachineCutCaseToType6,
  postSaveCaseName,
  postSetCommodityQuantityCap,
} from "@/openapi/erp/machine.js";
import { openDownloadWindow } from "@/utils/export.js";
import apiBaseURL from "@/utils/baseUrl.js";

const DISTRIBUTION_TYPE = {
  INBOUND_DISTRIBUTION: "1", // 入库分播
  DEFECTIVE_INSPECTOR_DISTRIBUTION: "2", // 按次品员分播
  MEDIAN_DISTRIBUTION: "3", // 按中分位
  RETURN_DISTRIBUTION: "4", // 按退供员
  MEDIAN_DISTRIBUTION_GROUP: "5", // 按中分位分组
  // 退换货分播
  RETURN_DISTRIBUTION_GROUP: "6",
};

// 其他配置选项重复提醒
const GRID_SELECT_TIPS = [
  "只允许一个格口“其他配置”选择“色差”",
  "只允许一个格口“其他配置”选择“微次”",
  "只允许一个格口“其他配置”选择“不出库格口”",
];
// 格口类型
const GRID_TYPE = {
  DEFECTIVE_AFTER_SALES: "8", // 售后次品
};

// 格口是否自动完成校验
const GRID_AUTO_CHECK =  {
  YES: 1,
  NO: 0,
}

export default {
  components: {
    Edit,
  },
  data() {
    return {
      DISTRIBUTION_TYPE,
      resData: { is_need_package: "0" },
      form: {
        machine_no: "",
        machine_id: "",
        grid_num: "",
      },
      loading: false,
      tableLoading: false,
      url: "/erp/Machine/machineList",
      filterFold: false,
      supplyData: null,
      visible: false,
      senders: [],
      sender: "",
      cpcode: "",
      // 设备分播配置
      machine_cut_case_setting: {
        machine_id: "", // 设备id
        machine_cut_type: "", // 分播类型
        case: [], // 方案 [{case_id:0,case: []}]
      },
      // 格口配置的下拉
      machine_grid_type: {},
      machine_case_name: "",
      action: `${apiBaseURL}/erp/Machine/importMachineCutCase`,
      configDialogVisible: false,
      configForm: {
        enableLimit: false,
        limit: 0, // 默认值
        currentCaseId: null,
        autoCheck: false
      },
      // 打印机绑定
      printerDialogVisible: false,
      addPrinterVisible: false,
      editingPrinter: false,
      printerList: [],
      boundPorts: [],
      unboundPorts: [],
      printerForm: {
        printer_name: "",
      },
      activeEditPrinterId: null,
      transferData: [],
      transferBinds: [],
      currentPrinterGridsChanges: []
    };
  },
  computed: {
    filteredForm() {
      // eslint-disable-next-line no-restricted-syntax
      for (const key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
    showOther() {
      return (
        this.machine_cut_case_setting.machine_cut_type ===
        DISTRIBUTION_TYPE.DEFECTIVE_INSPECTOR_DISTRIBUTION
      );
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    handleCurrentChange() {
      this.tableLoading = true;
      this.$http.post(this.url, this.form).then((res) => {
        setTimeout(() => {
          this.tableLoading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    fetchData(showLoading) {
      if (showLoading) {
        this.loading = true;
      }
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    beforeAddMachine() {
      this.form.machine_no = "";
      this.form.machine_id = "";
      this.form.grid_num = "";
      this.form.ip = "";
      this.form.port = "";
      this.form.is_check_one_out = "";
      this.visible = true;
    },
    closeBox() {
      this.fetchData();
      this.visible = false;
    },

    editMachine(row) {
      this.form.machine_no = row.machine_no;
      this.form.machine_id = row.machine_id;
      this.form.grid_num = row.grid_num;
      this.form.ip = row.ip;
      this.form.port = row.port;
      this.form.is_check_one_out = row.is_check_one_out;
      this.visible = true;
    },
    delMachine(row) {
      this.$confirm(`确认要删除此设备?`, "", {
        confirmButtonText: "确定",
        cancelButtonText: "不不不",
        type: "warning",
      }).then(() => {
        this.form.machine_id = row.machine_id;
        this.$http.post("/erp/machine/delMachine", this.form).then((res) => {
          this.loading = false;
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.$message.success(res.data.msg);
            this.visible = false;
            this.form.machine_id = "";
            this.fetchData();
          }
        });
      });
    },

    // 获取分播方案
    getCutCase() {
      const machineCutType = this.machine_cut_case_setting.machine_cut_type;
      const machineId = this.machine_cut_case_setting.machine_id;
      // 两个都选完才获取数据
      if (!machineCutType || !machineId) {
        return;
      }
      // 先重置掉
      this.$set(this.machine_cut_case_setting, "case", []);
      // 如果是退换货分播类型
      if (machineCutType === DISTRIBUTION_TYPE.RETURN_DISTRIBUTION_GROUP) {
        postGetMachineCutCaseToType6({
          machine_cut_type: machineCutType,
          machine_id: machineId,
        })
          .then((res) => {
            this.machine_cut_case_setting.case = res;
          })
          .catch(this.$noop);
      } else {
        this.$http
          .post("/erp/Machine/getMachineCutCaseDetail", {
            machine_id: this.machine_cut_case_setting.machine_id,
            machine_cut_type: this.machine_cut_case_setting.machine_cut_type,
          })
          .then((rs) => {
            const { code, data } = rs.data;
            if (code !== 200) {
              this.$message.e(rs.data.msg);
              return;
            }
            // 将 is_sc_grid 等于 0的值改成空字符串， 这样筛选项就不会显示0
            let newData = data;
            if (this.machine_cut_case_setting.machine_cut_type === "2") {
              newData = data.map((item) => {
                return {
                  ...item,
                  grid_setting: item.grid_setting.map((v) => {
                    return {
                      ...v,
                      is_sc_grid: v.is_sc_grid === "0" ? "" : v.is_sc_grid,
                    };
                  }),
                };
              });
            }
            this.$set(this.machine_cut_case_setting, "case", newData);
          });
      }
      this.getGridTypeSelection();
    },

    // 方案名的弹窗
    namePop() {
      const m = this.getMachinefield("machine_no");
      const t =
        this.resData.machine_cut_type[
          +this.machine_cut_case_setting.machine_cut_type - 1
        ].label;

      return this.$prompt(
        `<span style="font-size:16px">设备编号：${m}</span><br><span style="font-size:16px;margin-top:10px">分播类型：${t}</span>`,
        "输入方案名",
        {
          closeOnClickModal: false,
          inputPlaceholder: "请输入方案名",
          inputPattern: /^([0-9]|[a-zA-Z]|[\u4e00-\u9fa5]){1,20}$/, // 限制中文数字英文
          inputErrorMessage: "限制输入20个中文或英文或数字",
          dangerouslyUseHTMLString: true,
          inputValue: this.machine_case_name,
        }
      );
    },

    // 重命名方案名
    rename(caseIndex) {
      this.machine_case_name =
        this.machine_cut_case_setting.case[caseIndex].case_name;
      this.namePop().then((rs) => {
        // 退换货分播逻辑
        if (
          this.machine_cut_case_setting.machine_cut_type ===
          DISTRIBUTION_TYPE.RETURN_DISTRIBUTION_GROUP
        ) {
          const machineNameList = this.machine_cut_case_setting.case.map(
            (item) => item.case_name
          );
          if (machineNameList.includes(rs.value)) {
            this.$message.e("方案名不能重复");
            return;
          }
          postSaveCaseName({
            machine_cut_type: this.machine_cut_case_setting.machine_cut_type,
            machine_id: this.machine_cut_case_setting.machine_id,
            case_id: this.machine_cut_case_setting.case[caseIndex].case_id,
            case_name: rs.value,
          })
            .then(() => {
              this.$message.success("重命名成功");
              // 刷新配置方案
              this.getCutCase();
            })
            .catch(this.$noop);
          return;
        }
        this.$set(
          this.machine_cut_case_setting.case[caseIndex],
          "case_name",
          rs.value
        );
        this.machine_case_name = "";
      });
    },

    // 增加分播方案 - 输入方案名
    // @param type 1:重名,添加
    setCaseName() {
      if (!this.machine_cut_case_setting.machine_cut_type) {
        this.$message.e("请选择分播类型");
        return;
      }
      if (!this.machine_cut_case_setting.machine_id) {
        this.$message.e("请选择设备");
        return;
      }

      // 判断分播方案的上限
      const len = this.machine_cut_case_setting.case.length;
      // 入库分播方案只能有一个
      if (
        this.machine_cut_case_setting.machine_cut_type ===
          DISTRIBUTION_TYPE.INBOUND_DISTRIBUTION &&
        len >= 1
      ) {
        this.$message.e("入库类型的分播方案只能设置一套, 不可再添加");
        return;
      }
      if (len >= 3) {
        this.$message.e("此类型的分播方案最多设置三套, 不可再添加");
        return;
      }
      this.namePop().then((rs) => {
        if (
          this.machine_cut_case_setting.machine_cut_type ===
          DISTRIBUTION_TYPE.RETURN_DISTRIBUTION_GROUP
        ) {
          const machineNameList = this.machine_cut_case_setting.case.map(
            (item) => item.case_name
          );
          if (machineNameList.includes(rs.value)) {
            this.$message.e("方案名不能重复");
            return;
          }
        }
        this.machine_case_name = rs.value;
        this.addCutCase();
      });
    },

    // 增加分播方案
    addCutCase() {
      // 获取格口号 才能往下走
      this.$http
        .post("/erp/Machine/getGridByMachine", {
          machine_id: this.machine_cut_case_setting.machine_id,
        })
        .then((rs) => {
          if (rs.data.code !== 200) {
            this.$message.e(rs.data.msg);
            return;
          }
          const grids = rs.data.data;
          grids.forEach((v) => {
            // eslint-disable-next-line no-param-reassign
            v.case_detail_id = 0;
            // eslint-disable-next-line no-param-reassign
            v.cut_type =
              this.resData.machine_cut_type[
                +this.machine_cut_case_setting.machine_cut_type - 1
              ].label; // 分播类型
            // eslint-disable-next-line no-param-reassign
            v.grid_type =
              this.machine_cut_case_setting.machine_cut_type ===
              DISTRIBUTION_TYPE.INBOUND_DISTRIBUTION
                ? ""
                : []; // 格口类型 , 只有入库分播的时候是单选的
            // eslint-disable-next-line no-param-reassign
            v.max_cut_num = 0; // 最大分播数量
            // eslint-disable-next-line no-param-reassign
            v.is_sc_grid = "0";
          });
          // 分播类型做为下标
          this.machine_cut_case_setting.case.push({
            case_id: 0, // 配置id 0 为新增
            case_name: this.machine_case_name.trim(),
            grid_setting: grids,
          });
          this.machine_case_name = "";
        });
    },

    // 保存分播方案
    saveCutCase() {
      if (this.machine_cut_case_setting.case.length === 0) {
        this.$message.error("没有需要保存的数据");
        return;
      }
      this.$http
        .post("/erp/Machine/saveMachineCutCase", this.machine_cut_case_setting)
        .then((rs) => {
          if (rs.data.code !== 200) {
            this.$message.e(rs.data.msg);
            return;
          }
          this.getCutCase();
          this.$message.success(rs.data.msg);
        });
    },

    // 获取格口配置的下拉
    getGridTypeSelection() {
      const machineCutType = this.machine_cut_case_setting.machine_cut_type;
      if (this.machine_grid_type[machineCutType]) {
        this.$set(
          this.machine_grid_type,
          machineCutType,
          this.machine_grid_type[machineCutType]
        );
        return;
      }
      // 重置为空
      this.$set(this.machine_grid_type, machineCutType, []);
      // 如果是退换货分播类型
      if (machineCutType === DISTRIBUTION_TYPE.RETURN_DISTRIBUTION_GROUP) {
        return;
      }
      this.$http
        .post("/erp/Machine/getMachineCutGridType", {
          machine_cut_type: machineCutType,
        })
        .then((rs) => {
          if (rs.data.code !== 200) {
            this.$message.error(rs.data.msg);
            return;
          }
          this.$set(this.machine_grid_type, machineCutType, rs.data.data);
        });
    },

    // 获取设备信息
    getMachinefield(field) {
      let rs = null;
      this.resData.list.every((v) => {
        if (v.machine_id == this.machine_cut_case_setting.machine_id) {
          rs = v[field];
          return false;
        }
        return true;
      });
      return rs;
    },

    // 删除分播方案
    removeCase(key) {
      const { case_id } = this.machine_cut_case_setting.case[key];
      const { case_name } = this.machine_cut_case_setting.case[key];
      let msg = `是否确定删除方案: ${case_name}?`;
      if (case_id == 0) {
        msg = `方案: ${case_name}, 尚未保存, 是否确定删除?`;
      }
      this.$confirm(msg, "删除方案", {
        closeOnClickModal: false,
      }).then((rs) => {
        if (case_id == 0) {
          this.machine_cut_case_setting.case.splice(key, 1);
          this.$message.success("删除方案成功");
        } else {
          this.$http.post("/erp/Machine/removeCase", { case_id }).then((rs) => {
            if (rs.data.code != 200) {
              return this.$message.e(rs.data.msg);
            }
            this.$message.success("删除方案成功");
            this.getCutCase();
          });
        }
      });
      // console.log(this.machine_cut_case_setting.case[key])
    },

    // 勾选色差
    checkScGrid(value, setting, selfIndex) {
      // console.log(e);
      if (String(value) === "1") {
        // 如果勾选了 则把选中的次品员去掉 且禁用掉选择框
        // eslint-disable-next-line no-param-reassign
        setting[selfIndex].grid_type = [];
        setting.forEach((v, index) => {
          // 把其他格口的勾选给去掉, 只能勾选一个格口
          if (selfIndex !== index && v.is_sc_grid === "1") {
            // eslint-disable-next-line no-param-reassign
            v.is_sc_grid = "0";
          }
        });
      }
    },
    // 更改其他配置项
    selectScGrid(value, scoped, gridList) {
      // console.log("vaule", value, scoped, gridList);
      const hasValueItem = gridList.find((item) => item.is_sc_grid === value);
      console.log("hasValueItem", hasValueItem);
      if (hasValueItem) {
        // 排除等于空字符串的情况
        if (hasValueItem.is_sc_grid !== "") {
          this.$message.warning(GRID_SELECT_TIPS[value - 1]);
          hasValueItem.is_sc_grid = "";
        }
      }

      // eslint-disable-next-line no-param-reassign
      scoped.is_sc_grid = value;
      // eslint-disable-next-line no-param-reassign
      scoped.grid_type = [];
    },
    // 监听更换格口配置
    onGridTypeChange(value, index, scope) {
      const { case: caseList } = this.machine_cut_case_setting;
      const gridSetting = caseList[index].grid_setting.map((item) => {
        if (item.grid_id === scope.grid_id) {
          return { ...item, grid_type: value };
        }
        // 判断列表格口配置中是否已存在售后次品类型，若有则清空。
        if (
          value === GRID_TYPE.DEFECTIVE_AFTER_SALES &&
          item.grid_type === GRID_TYPE.DEFECTIVE_AFTER_SALES
        ) {
          this.$message.warning("只允许一个格口配置为售后次品");
          return { ...item, grid_type: "" };
        }
        return item;
      });
      caseList[index].grid_setting = gridSetting;
    },
    handleUploadResult(res) {
      if (res.code !== 200) {
        this.$message.e(res.msg);
        openDownloadWindow(res.data);
      } else {
        this.$message.success("导入成功");
        this.getCutCase();
      }
      // 此项是数组，因此遍历清空文件
      this.$refs.upload.forEach((v) => v.clearFiles());
    },
    showConfig(item) {
      // 设置配置值到表单
      console.log("res", item);
      this.configForm.enableLimit = item.is_commodity_quantity_cap == 1;
      this.configForm.limit = item.commodity_quantity_cap || 0;
      this.configForm.currentCaseId = item.case_id;
      this.configForm.autoCheck = item.auto_check == GRID_AUTO_CHECK.YES;
      this.configDialogVisible = true;
    },

    handleConfigSubmit() {
      if (this.configForm.enableLimit) {
        if (!this.configForm.limit || this.configForm.limit <= 0) {
          this.$message.error("请填写正确的商品数量上限");
          return;
        }
      }
      // 调用API保存配置
      postSetCommodityQuantityCap({
        case_id: this.configForm.currentCaseId,
        is_commodity_quantity_cap: this.configForm.enableLimit ? 1 : 2,
        commodity_quantity_cap: this.configForm.limit,
        auto_check: this.configForm.autoCheck ? GRID_AUTO_CHECK.YES : GRID_AUTO_CHECK.NO,
      })
        .then(() => {
          this.getCutCase();
          this.$message.success("配置保存成功");
          this.configDialogVisible = false;
        })
        .catch(this.$noop);
    },
    // 显示打印机绑定弹窗
    showBindPrinter() {
      if(!this.machine_cut_case_setting.machine_id) {
        return this.$message.warning("请先选择设备！");
      }
      this.printerDialogVisible = true;
      this.getPrinterList();
    },

    // 获取打印机列表
    getPrinterList() {
      this.$http
        .post("/erp/Printer/index", {
          machine_id: this.machine_cut_case_setting.machine_id,
        })
        .then((res) => {
          if (res.data.code === 200) {
            this.printerList = res.data.data || [];
          }
        });
    },

    // 显示新增打印机弹窗
    showAddPrinter() {
      this.editingPrinter = false;
      this.printerForm = { printer_name: "" };
      this.addPrinterVisible = true;
    },

    // 关闭打印机绑定弹窗
    handleClosePrinterModal() {
      this.printerDialogVisible = false;
      this.activeEditPrinterId = null;
      this.transferData = [];
      this.transferBinds = [];
      this.currentPrinterGridsChanges = [];
    },

    // 编辑打印机
    editPrinter(row) {
      this.editingPrinter = true;
      this.printerForm = {
        printer_name: row.printer_name,
        // ip: row.ip,
        id: row.id
      };
      this.activeEditPrinterId = null;
      this.addPrinterVisible = true;
    },

    // 删除打印机
    deletePrinter(row) {
      this.$confirm("是否删除该打印机，并解绑相关格口号?", "", {
        type: "warning",
      }).then(() => {
        this.$http
          .post("/erp/Printer/delete", {
            id: row.id,
          })
          .then((res) => {
            if (res.data.code === 200) {
              this.$message.success("删除成功");
              this.getPrinterList();
            }
          });
      });
    },

    handleTransferChange(value, direction, movedKeys) {
      console.log(value, direction, movedKeys);
      if(direction === 'right' || direction === 'left') {
        const list = this.transferData.filter(e => !value.includes(e.key)).map(e => e.key);
        this.currentPrinterGridsChanges = list;
      }
    },

    // 添加 | 修改打印机
    handleAddPrinter() {
      this.$http
        .post(this.editingPrinter ? "/erp/Printer/save" : "/erp/Printer/create", {
          ...this.printerForm,
          machine_id: this.machine_cut_case_setting.machine_id,
        })
        .then((res) => {
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
            return;
          }
          this.$message.success(this.editingPrinter ? "修改成功":"添加成功");
          this.addPrinterVisible = false;
          this.getPrinterList();
        });
    },

    handleEditMode(row) {
      this.activeEditPrinterId = row.id;
      this.$http
        .post("/erp/Printer/grids", {
          id: row.id,
        })
        .then((res) => {
          if (res.data.code === 200) {
            this.transferData = [
              ...res.data.data.binds,
              ...res.data.data.noBinds
            ].map(e => ({
              key: e.grid_id,
              label: e.grid_no
            }));
            this.transferBinds = res.data.data.noBinds.map(e => e.grid_id);
            this.currentPrinterGridsChanges = res.data.data.binds.map(e => e.grid_id);
          }
        });
    },

    // 保存打印机格口绑定
    savePrinterBinding(){
      if(!this.activeEditPrinterId){
        this.$message.warning("请先选择打印机");
        return;
      }
      this.handleSaveBind(this.currentPrinterGridsChanges)
    },

    // 打印机绑定格口
    handleSaveBind(list){
      this.$http
        .post("/erp/Printer/bindGrids", {
          id: this.activeEditPrinterId,
          grids: list,
          machine_id: this.machine_cut_case_setting.machine_id,
        })
        .then((res) => {
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
            return;
          }
          this.$message.success("操作成功");
          this.handleClosePrinterModal();
        });
    }
  },
};
</script>

<style scoped lang="less">
.row {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 12px;
}

.column {
  text-align: center;
  border: 1px solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}

.line-2 {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}

.transfer-container {
  display: flex;
  align-items: flex-start;
  gap: 20px; /* 两个组件之间的间距 */
}

.transfer {
  flex: 1; /* 各占50%宽度 */
}

.el-table {
  flex: 1; /* 各占50%宽度 */
}

/deep/ .el-transfer-panel {
  height: 600px;
  &__body{
    height: 600px;
    .el-transfer-panel__list{
      height: 600px - 100;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/machine/machineList.vue